module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "download-contract"
  }, [_c('vue-pdf-viewer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "download-contract",
    attrs: {
      "url": _vm.src,
      "height": _vm.height
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-747ca6c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/management/contract/contract.vue
// module id = 1120
// module chunks = 1